
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gvkh5lAu9VhVLKfApnNoyZHazLUt741FtbU_gnB84ndoMeta } from "/codebuild/output/src1588851203/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as index0Gzs_sah4tCw9YZUwHgzp9l_45sN6ModxOs8mPZespwc4Meta } from "/codebuild/output/src1588851203/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchenzamW4RJGdEi0X8GhlIe2eqKy6juqeq3fJUku_RV1sMeta } from "/codebuild/output/src1588851203/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexA8s1CtQHsL3c8ixcwCjONCkUQhMR8bHrfO_tzJ8ySpcMeta } from "/codebuild/output/src1588851203/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93INvLZbuXeMcgwNR09UAAK1lLw28lm3fnT8RfopnnWz0Meta } from "/codebuild/output/src1588851203/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexFyq5xCmw2fQfiLRdi43_45S96p7sBG9khn9G0Pxzr0PEAMeta } from "/codebuild/output/src1588851203/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93j_450HOrIObQRPCo2PjpITBQEugn758vZ_455R9_qsnHB2oMeta } from "/codebuild/output/src1588851203/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexJYrqvklOKcNtvuVsissGlEHHaIANOs_45tUsrAX_IwhfMMeta } from "/codebuild/output/src1588851203/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_930OFDdmZmcBigXq1_yCAFIzGlSuVbOgM_4552AgnsU_wLMMeta } from "/codebuild/output/src1588851203/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexAPxPNOp_451CaTXu3P_45ZE4J3hpCHfhttruhMuPuEHTezcMeta } from "/codebuild/output/src1588851203/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexLXagyPTyQQLpCYIwTp4FcLPLSAJODS6AFd8Yz45qBE8Meta } from "/codebuild/output/src1588851203/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src1588851203/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1588851203/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src1588851203/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src1588851203/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src1588851203/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexFyq5xCmw2fQfiLRdi43_45S96p7sBG9khn9G0Pxzr0PEAMeta || {},
    component: () => import("/codebuild/output/src1588851203/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src1588851203/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexJYrqvklOKcNtvuVsissGlEHHaIANOs_45tUsrAX_IwhfMMeta || {},
    component: () => import("/codebuild/output/src1588851203/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src1588851203/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexAPxPNOp_451CaTXu3P_45ZE4J3hpCHfhttruhMuPuEHTezcMeta || {},
    component: () => import("/codebuild/output/src1588851203/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexLXagyPTyQQLpCYIwTp4FcLPLSAJODS6AFd8Yz45qBE8Meta || {},
    component: () => import("/codebuild/output/src1588851203/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]